import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/nav.scss";
import { Container, Button, Alert } from "react-bootstrap";
import { CSSTransition } from "react-transition-group";
import NavBarPhone from "react-hamburger-menu";

let w = window;
let activeIndex = 0;

class NavPhone extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showMenu: false };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
  }

  toggleMenu() {
    this.setState({ showMenu: !this.state.showMenu });
  }

  handleSelection(el) {
    activeIndex = el.target.tabIndex;
    this.props.handleSelection([activeIndex], true);
    this.setState({ showMenu: !this.state.showMenu });
  }

  componentDidUpdate() {
    if (w["tools_category"] && activeIndex != 1) {
      activeIndex = 1;
      this.props.handleSelection([activeIndex], false);
    }
  }

  render() {
    const nodeRef = React.createRef();
    return (
      <Container className="phone-nav-view" style={{ paddingTop: "2rem" }}>
        <div className="phone-nav-button-holder">
          <NavBarPhone
            isOpen={this.state.showMenu}
            menuClicked={this.toggleMenu}
            width={18}
            height={15}
            strokeWidth={3}
            rotate={0}
            color={this.props.navButtons[activeIndex].color}
            borderRadius={0}
            animationDuration={0.5}
            className={"phone-nav-button"}
          />
          <a
            className={
              "phone-nav-label " + this.props.navButtons[activeIndex].ref
            }
          >
            Menu
          </a>
        </div>
        <CSSTransition
          in={this.state.showMenu}
          timeout={300}
          classNames="dropdown-menu"
          nodeRef={nodeRef}
          unmountOnExit
        >
          <div
            variant="primary"
            dismissible="true"
            className={"dropdown-menu"}
            ref={nodeRef}
          >
            {this.props.navButtons.map((button, i) => (
              <div
                tabIndex={i}
                onClick={this.handleSelection}
                className={"nav-option " + button.ref}
              >
                {button.label}
              </div>
            ))}
          </div>
        </CSSTransition>
      </Container>
    );
  }
}

export default NavPhone;
